// src/utils/chunkLoadRecovery.js
//
// BUG-051 — tela que "não abre" depois de um deploy, até Ctrl+Shift+R.
//
// O QUE ACONTECE. As telas são carregadas sob demanda (`() => import(...)`), e o
// nome de cada pedaço leva o hash do build (`js/chunk-3f2a….js`). Uma aba aberta
// antes do deploy ainda roda o bundle antigo, que conhece só os hashes antigos.
// Quando o operador clica numa tela que ainda não tinha aberto, o browser pede um
// arquivo que não existe mais nos pods novos → 404 → o `import()` rejeita com
// ChunkLoadError → o vue-router aborta a navegação. Sem tratamento, nada aparece:
// o clique no menu simplesmente não faz nada, e o único remédio que a pessoa
// conhece é limpar cache e recarregar.
//
// A SAÍDA. Recarregar a página NA ROTA que se tentou abrir. A navegação é
// network-first no service worker e o nginx serve o index.html com `no-cache`,
// então o reload sobe na build nova, que conhece os hashes certos.
//
// A trava de tempo evita laço: se o arquivo faltar também na build nova (deploy
// quebrado, pod antigo ainda no balanceador durante o rollout), recarregar de
// novo não resolveria — então só uma vez por janela, e o erro segue para o log.

import { logger } from "@/utils/logger";

const RELOAD_KEY = "chunkReloadAt";
const RELOAD_WINDOW_MS = 30 * 1000;

export function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === "ChunkLoadError") return true;
  const message = String(error.message || "");
  return (
    /Loading (CSS )?chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

function lastReloadAt(storage) {
  try {
    return Number(storage.getItem(RELOAD_KEY)) || 0;
  } catch {
    return 0;
  }
}

function markReload(storage, now) {
  try {
    storage.setItem(RELOAD_KEY, String(now));
  } catch {
    /* sem storage: a trava some, mas o reload ainda vale uma vez */
  }
}

/**
 * Trata a falha de carregar um pedaço do app recarregando na rota de destino.
 * @returns {boolean} true se disparou o reload.
 */
export function recoverFromChunkLoadError(
  error,
  targetPath,
  {
    storage = window.sessionStorage,
    location = window.location,
    now = Date.now(),
  } = {}
) {
  if (!isChunkLoadError(error)) return false;

  if (now - lastReloadAt(storage) < RELOAD_WINDOW_MS) {
    logger.error(
      "[chunk] pedaço do app segue indisponível após recarregar — não repetindo",
      error
    );
    return false;
  }

  markReload(storage, now);
  logger.warn("[chunk] build nova detectada ao navegar — recarregando", {
    targetPath,
  });
  if (targetPath) {
    location.assign(targetPath);
  } else {
    location.reload();
  }
  return true;
}
